import { render, staticRenderFns } from "./certificate_a4.vue?vue&type=template&id=6d39bdc1&scoped=true"
import script from "./certificate_a4.vue?vue&type=script&lang=js"
export * from "./certificate_a4.vue?vue&type=script&lang=js"
import style0 from "./certificate_a4.vue?vue&type=style&index=0&id=6d39bdc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d39bdc1",
  null
  
)

export default component.exports